<template>
  <div>
    <div v-if="pageLoading" class="text-center" style="padding: 80px 0;">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Carregando...</span>
      </div>
      <p class="mt-2">Carregando...</p>
    </div>
    <div class="main-content" v-else>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Unidade</div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="col-md-12">
              <form action>
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label for="Name">
                      <span class="required">*</span> Nome da Unidade:
                    </label>
                    <input
                      autocomplete="new-password"
                      type="text"
                      id="Name"
                      class="form-control"
                      v-model="clientUnit.name"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group col-md-5">
                    <label>
                      <span class="required">*</span> Cliente:
                    </label>
                    <v-select
                      v-model="clientUnit.client_id"
                      :options="clients"
                      :reduce="(clients) => clients.id"
                      :label="'company_name'"
                    ></v-select>
                  </div>
                  <div class="form-group col-md-2">
                    <label>ID da Unidade <span class="text-muted">(opcional)</span>:</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="clientUnit.unit_id"
                      placeholder="Ex: 526"
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-2">
                    <label>CEP</label>
                    <input
                      v-model="clientUnit.cep"
                      type="tel"
                      class="form-control"
                      v-mask="'99999-999'"
                    />
                  </div>
                  <div class="form-group col-md-5">
                    <label>Logradouro</label>
                    <input
                      v-model="clientUnit.street"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label>Número</label>
                    <input
                      v-model="clientUnit.number"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group col-md-3">
                    <label>Bairro</label>
                    <input
                      v-model="clientUnit.neighborhood"
                      type="text"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="form-row">
                  <template v-if="!ibgeIndisponivel">
                    <div class="form-group col-md-2">
                      <label>Estado</label>
                      <select v-model="clientUnit.state" class="form-control" @change="carregarCidades">
                        <option value="">Selecione</option>
                        <option v-for="estado in estados" :key="estado.id" :value="estado.sigla">
                          {{ estado.nome }}
                        </option>
                      </select>
                    </div>
                    <div class="form-group col-md-5">
                      <label>Cidade</label>
                      <select
                        v-model="clientUnit.city"
                        class="form-control"
                        :disabled="!clientUnit.state || carregandoCidades"
                      >
                        <option value="">{{ carregandoCidades ? "Carregando cidades..." : "Selecione" }}</option>
                        <option v-for="cidade in cidades" :key="cidade.id" :value="cidade.nome">
                          {{ cidade.nome }}
                        </option>
                      </select>
                    </div>
                  </template>
                  <template v-else>
                    <div class="form-group col-md-2">
                      <label>Estado</label>
                      <input
                        v-model="clientUnit.state"
                        type="text"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group col-md-5">
                      <label>Cidade</label>
                      <input
                        v-model="clientUnit.city"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </template>
                  <div class="form-group col-md-3">
                    <label>Complemento</label>
                    <input
                      v-model="clientUnit.complement"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label>
                      <span class="required">*</span> Status:
                    </label>
                    <select v-model="clientUnit.status" class="form-control">
                      <option :value="1">Ativo</option>
                      <option :value="0">Inativo</option>
                    </select>
                  </div>
                </div>
                <span class="required_fields">
                  <span class="required">*</span>
                  <strong>Campos obrigatórios</strong>
                </span>
                <div class="block text-right mb-1">
                  <router-link to="/client_units" class="btn btn-back">
                    <i class="fa fa-arrow-left"></i> Voltar
                  </router-link>
                  <a class="btn btn-add ml-1" @click="save">
                    Salvar
                    <i class="fa fa-save"></i>
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";

export default {
  name: "clientUnitAdd",
  data() {
    return {
      pageLoading: true,
      clientUnit: {
        name: "",
        unit_id: "",
        client_id: "",
        cep: "",
        street: "",
        number: "",
        complement: "",
        neighborhood: "",
        city: "",
        state: "",
        status: "",
      },
      clients: [],
      estados: [],
      cidades: [],
      ibgeIndisponivel: false,
      carregandoCidades: false,
    };
  },
  components: {
    vSelect,
  },
  methods: {
    carregarEstados: function () {
      const self = this;
      return axios
        .get("https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome")
        .then((response) => {
          self.estados = response.data;
        })
        .catch(() => {
          self.ibgeIndisponivel = true;
        });
    },
    carregarCidades: function () {
      const self = this;
      self.cidades = [];

      if (!self.clientUnit.state) return;

      self.carregandoCidades = true;
      return axios
        .get(
          "https://servicodados.ibge.gov.br/api/v1/localidades/estados/" +
            self.clientUnit.state +
            "/municipios"
        )
        .then((response) => {
          self.cidades = response.data;
        })
        .catch(() => {
          self.ibgeIndisponivel = true;
        })
        .finally(() => {
          self.carregandoCidades = false;
        });
    },
    getClients: function () {
      const self = this;
      const api = self.$store.state.api + "clients/?status=1";

      return axios
        .get(api)
        .then((response) => {
          self.clients = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "client_units";

      if (self.clientUnit.id) {
        api += "/" + self.clientUnit.id;
        self.clientUnit._method = "PUT";
      }

      axios
        .post(api, self.clientUnit)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/client_units");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getClientUnit: function (id) {
      const self = this;
      const api = self.$store.state.api + "client_units/" + id;

      return axios
        .get(api)
        .then((response) => {
          self.clientUnit = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  async mounted() {
    const self = this;
    let id = self.$route.params.id;

    self.pageLoading = true;

    try {
      await Promise.all([self.getClients(), self.carregarEstados()]);

      if (id) {
        await self.getClientUnit(id);

        if (!self.ibgeIndisponivel) {
          await self.carregarCidades();
        }
      }
    } catch (e) {
      console.error(e);
    } finally {
      self.pageLoading = false;
    }
  },
};
</script>
